import { createFileRoute } from "@tanstack/react-router";
import { preloadLazyModule } from "src/lib/LazyModules";
import PolicyOverviewPage from "src/routes/_authed/portal/-components/moderation-policies/PolicyOverviewPage";

export const Route = createFileRoute(
  "/_authed/portal/org_{$orgKey}/moderation-policies/$policyId/",
)({
  loader: async () => {
    await preloadLazyModule("moderationPlayground");
  },
  component: PolicyOverviewPage,
});
